module.exports = __webpack_public_path__ + "img/mars-stroke-up.36017d5c.svg";